import React, { useState } from "react";

const ImageUpload = ({ question, accept, value, onChange }) => {
  const [preview, setPreview] = useState(value?.preview || null);
  const [fileName, setFileName] = useState(value?.name || "");
  const [error, setError] = useState("");

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    setError("");
    if (!file) return;

    if (!file.type.startsWith("image/")) {
      setError("Please upload only image files");
      return;
    }

    const maxSize = 5 * 1024 * 1024;
    if (file.size > maxSize) {
      setError("File size should not exceed 5MB");
      return;
    }

    const reader = new FileReader();
    reader.onloadend = () => {
      setPreview(reader.result);
      setFileName(file.name);
      onChange({ file, preview: reader.result, name: file.name });
    };
    reader.readAsDataURL(file);
  };

  const handleRemove = () => {
    setPreview(null);
    setFileName("");
    setError("");
    onChange(null);
  };

  return (
    <div className="image-upload-question">
      <h4 className="question-text mb-4">{question}</h4>
      {!preview ? (
        <div className="upload-area border rounded p-4 text-center">
          <input
            type="file"
            id="image-upload"
            className="d-none"
            accept={accept}
            onChange={handleFileChange}
          />
          <label htmlFor="image-upload" className="btn btn-outline-primary btn-lg">
            Choose Image
          </label>
          <p className="mt-3 text-muted">
            Accepted formats: JPG, PNG, GIF (Max size: 5MB)
          </p>
        </div>
      ) : (
        <div className="preview-area text-center">
          <img
            src={preview}
            alt="Preview"
            className="img-fluid rounded mb-3"
            style={{ maxHeight: "300px" }}
          />
          <p className="text-muted">{fileName}</p>
          <button className="btn btn-outline-danger" onClick={handleRemove}>
            Remove
          </button>
        </div>
      )}
      {error && <div className="alert alert-danger mt-3">{error}</div>}
    </div>
  );
};

export default ImageUpload;
